import React, { FC } from 'react';
import './DateTimeField.css';
import { ErrorMessage, Field } from '@/Shared/Lib/Logic';
import { FaCalendarAlt, FaClock } from 'react-icons/fa';

interface DateTimeFieldProps {
	label: string,
	timeName?: string,
	dateName: string,
	readOnly?: boolean
	required?: boolean,
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
	dateValue?: any,
	timeValue?: any,
	withIcon?: boolean,
	datePlaceholder?: string,
	timePlaceHolder?: string

}

const DateTimeField: FC<DateTimeFieldProps> = ({
	label, timeName, dateName, readOnly = false,
	required = false,
	onChange,
	dateValue,
	timeValue,
	withIcon = true,
	datePlaceholder,
	timePlaceHolder
}) => (

	<label
		className={`DateTimeField data-field-label ${readOnly ? 'readonly' : ''}`}
		data-testid="DateTimeField"
		title={readOnly ? 'Champ non modifiable' : 'Champ modifiable'}>
		<div>{label} {required && <span className="asterisk" aria-hidden="true"> *</span>}</div>
		<div className="form-group-wrapper">
			<div className="form-group">
				<div className='Field-wrapper'>
					{withIcon && <div className='field-icon'><FaCalendarAlt /></div>}
					<Field
						readOnly = {readOnly}
						name={dateName}
						type='date'
						className="input-field"
						placeholder={datePlaceholder || label}
						{...(onChange ? { onChange } : {})}
						{...(dateValue ? { value : dateValue } : {})}
					/>
				</div>
				<ErrorMessage name={dateName} component="div" className="error-message" />
			</div>
			{timeName && <div className="form-group">
				<div className='Field-wrapper'>
					{withIcon && <div className='field-icon'><FaClock /> </div>}
					<Field
						readOnly
						name={timeName}
						type='time'
						step='900'
						className="input-field"
						placeholder={timePlaceHolder ?? "HH:MM"}
						{...(onChange ? { onChange } : {})}
						{...(timeValue ? { value : timeValue } : {})}
					/>
				</div>
				<ErrorMessage name={timeName} component="div" className="error-message" />
			</div>}
		</div>
	</label>

);

export default DateTimeField;
